<template>
	<div
		:class="[
			`${baseClass}`,
			{
				[`${baseClass}--disabled`]: disabled
			}
		]"
	>
		<button
			type="button"
			:class="`${baseClass}-minus`"
			:disabled="disabled || locked || quantity <= min"
			@click.prevent="$emit('sub')"
		>
			<SVGMinus/>
		</button>
    <input
      v-if="writable"
      :class="`${baseClass}-input`"
      type="number"
      :step="1"
      :min="min"
      :max="max"
      :value="quantity"
      @input="updateQuantity"
      @click="quantityClick"
    />
		<span
      v-else
			:class="`${baseClass}-value`"
			v-html="quantity"
		/>
		<button
			type="button"
			:class="`${baseClass}-plus`"
			:disabled="disabled || locked || quantity >= max"
			@click.prevent="$emit('add')"
		>
			<SVGPlus/>
		</button>
	</div>
</template>

<script>
export default {
	props: {
		baseClass: String,
		quantity: Number,
		disabled: Boolean,
		locked: Boolean,
		min: {
			type: Number,
			default: 0,
		},
		max: {
			type: Number,
			default: Infinity,
		},
    writable: Boolean
	},
  methods: {
    updateQuantity(e) {
      const newQuantity = e.target.value
      this.$emit('update', Math.max(Math.min(newQuantity, this.max), this.min))
    },
    quantityClick(e) {
      e.target.select()
    }
  }
}
</script>

<style>

</style>
